import Success from '../components/successpage/Success';

const SuccessPage = () => {
    return (
        <>
            <Success />
        </>
    );
};

export default SuccessPage;
